import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { PostAddNewAlertPayload, PostAddNewAlertResponse } from '@/api/customSensorAlerts/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';

export const postAddNewAlert = (args: PostAddNewAlertPayload): Promise<PostAddNewAlertResponse> => {
    const { spotterId, ...payload } = args;
    return axios.post(`/user-rest/devices/${spotterId}/alert-configurations`, {
        ...payload,
        trigger_details: JSON.stringify(payload.trigger_details),
    });
};

type UsePostAddNewAlertOptions = {
    config?: MutationConfig<typeof postAddNewAlert>;
    data?: PostAddNewAlertPayload;
};

export const usePostAddNewAlert = ({ config }: UsePostAddNewAlertOptions = {}) => {
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postAddNewAlert,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ['device-alerts-configuration', { spotterId: variables.spotterId }],
            });
            mixpanel?.track('Sensor alert created', {
                spotterId: variables.spotterId,
                alertType: variables.trigger_details.displayName,
                details: `${variables.trigger_details.operator} ${variables.trigger_details.value} ${variables.trigger_details.units}`,
                sensorPosition: variables.trigger_details.sensorPosition ?? null,
            });
        },
    });
};
